import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { createPortal } from "react-dom";

export default function DeleteWidgetConfirm({
  onDelete,
  onCancel,
  className,
  popoverClassName,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const buttonRef = useRef(null);
  const popoverRef = useRef(null);
  const [popoverPosition, setPopoverPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popoverRef.current &&
        !popoverRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isVisible && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPopoverPosition({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
  }, [isVisible]);

  return (
    <>
      <button
        ref={buttonRef}
        onClick={() => setIsVisible(!isVisible)}
        className={className}
        title="Delete widget"
      >
        <FontAwesomeIcon
          icon={faTrash}
          size="xs"
          className="text-accent-coral"
        />
      </button>

      {isVisible &&
        createPortal(
          <div
            ref={popoverRef}
            style={{
              position: "fixed",
              top: `${popoverPosition.top}px`,
              left: `${popoverPosition.left}px`,
              zIndex: 999999,
            }}
            className="bg-dark-surface rounded-lg shadow-lg p-3 w-48"
          >
            <div className="text-center">
              <p className="text-sm text-white mb-3">
                Are you sure you want to delete this widget?
              </p>
              <div className="flex gap-2 justify-center">
                <button
                  onClick={() => {
                    onDelete();
                    setIsVisible(false);
                  }}
                  className="px-3 py-1 bg-accent-coral text-white rounded-md text-sm hover:bg-accent-coral/80 transition-colors"
                >
                  Delete
                </button>
                <button
                  onClick={() => {
                    setIsVisible(false);
                    onCancel?.();
                  }}
                  className="px-3 py-1 bg-dark-elevated text-white rounded-md text-sm hover:bg-dark-elevated/80 transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}
